// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__bct2L","rotate":"Spinner_rotate__434Q0","background":"Spinner_background__eaemQ","path":"Spinner_path__G3prB","dash":"Spinner_dash__1zjGS"};